import React from 'react';
import _ from 'lodash';
import { object, number, string } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import GigCardListings from '@fiverr-private/gig_listings/src/entries/GigCardListings';
import './index.scss';

export default function Gigs({ gigData, sellerName, userId, currency, pageCtxId, abTestsProps }) {
    const { gigs, gigCollect } = gigData;

    const context = {
        userId,
        currency,
        pageCtxId,
        abTestsProps,
        sourcePage: 'user_page',
        viewportType: 'user_page.gigs',
        controllerAction: 'user_page#index'
    };

    const features = {
        gigInNewTab: true
    };

    return (
        <section className="gigs-wrapper">
            <header>
                <h2><I18n k="user_page_perseus.users_gigs" params={{ sellerName }}/></h2>
            </header>

            {_.isEmpty(gigs) &&
                <div className="no-gigs">
                    <I18n k="user_page_perseus.no_gigs" params={{ sellerName }}/>
                </div>}

            <GigCardListings gigs={gigs} gigCollect={gigCollect}
                context={context} features={features}/>
        </section>
    );
}

Gigs.propTypes = {
    gigData: object,
    sellerName: string,
    userId: number,
    currency: object,
    pageCtxId: string
};
